import React, { useReducer, useEffect, useContext } from "react";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";
import AlertasContext from "../Alertas/AlertasContext";

import clienteAxios from "../../Services/clienteAxios";
import tokenAuth from "../../Services/token";
import {
  LOGIN_EXITOSO,
  REGISTRO_EXITOSO,
  OBTENER_USUARIO,
  CERRAR_SESION,
} from "../../types";

const AuthState = ({ children }) => {
  const { mostrarAlerta } = useContext(AlertasContext);

  const registrarUsuario = async (data) => {
    try {
      const response = await clienteAxios.post("/api/usuario", data);
      console.log(response, "respuesta");
      console.log(response.data);
      mostrarAlerta(response.data.msg);

      dispatch({ type: REGISTRO_EXITOSO, payload: response.data });
      usuarioAutenticado();
    } catch (error) {
      console.log(error.response);
    }
  };
  const usuarioAutenticado = async () => {
    const token = localStorage.getItem("token");

    if (token) {
      tokenAuth(token);
    }
    try {
      const response = await clienteAxios.get("/api/auth");
      dispatch({ type: OBTENER_USUARIO, payload: response.data.usuario });
      console.log(response);
    } catch (error) {
      console.log(error.response);
    }
  };

  const iniciarSesion = async (data) => {
    try {
      console.log("object");
      const respuesta = await clienteAxios.post("/api/auth", data);
      dispatch({ type: LOGIN_EXITOSO, payload: respuesta.data });
    } catch (error) {
      console.log(error.response.data.msg, "ERROR");
      console.log(error.msg);
      mostrarAlerta(error.response.data.msg);
    }
  };

  const cerrarSesion = async () => {
    dispatch({ type: CERRAR_SESION, payload: initialState });
  };

  const initialState = {
    token: null,
    usuario: null,
    autenticado: null,
  };
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Se está haciendo algo");
    tokenAuth(token);
    if (token) {
      usuarioAutenticado();
    }
  }, [state.token]);

  return (
    <AuthContext.Provider
      value={{
        usuario: state.usuario,
        autenticado: state.autenticado,
        registrarUsuario,
        iniciarSesion,
        cerrarSesion,
        usuarioAutenticado,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthState;
